import { render } from "./RecordBatch.vue?vue&type=template&id=e51c24d8"
import script from "./RecordBatch.vue?vue&type=script&lang=js"
export * from "./RecordBatch.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__